<template>
  <div>
    <myHeader class="my-header"></myHeader>

    <div class="demo-collapse mobile">
      <div class="product">
        <div class="fadeinup-titleb">PRODUCT</div>
        <div class="product-title">公司产品</div>

        <div class="product-list">
          <div class="product-cell">
            <div class="cell-left">
              <img class="product-img" src="../assets/product/zz.jpg" alt="" />
              <!-- <div class="product-name">粽子</div> -->
            </div>
            <div class="cell-right">
              <strong>经典咸粽 · 匠心入馅</strong><br />
              选用高邮湖产区咸鸭蛋黄，搭配肥瘦相宜的五花肉，经秘制酱料腌制入味。糯米吸饱肉汁油脂，咸香丰腴，沙软蛋黄与紧实肉块在口中交织，是念念不忘的家乡味。<br />
              <strong> 清香甜粽 · 本味回归</strong><br />
              优选东北黑土地饱满红小豆，手工熬煮成绵密豆沙，保留颗粒感。箬叶清香渗入糯米，豆沙清甜不腻，入口软糯，还原食材本真的自然甜香。<br />
              <strong> 产品亮点</strong> <br />
              产地严选：从产地到工厂全程溯源，确保原料安心。<br />
              蒸煮工艺：沿用传统蒸煮技艺，保留粽子软糯筋道的口感。<br />
              定制礼盒：支持企业专属定制，自食送礼皆相宜<br />
              <strong> 甜咸皆备，总有一味慰藉乡愁。</strong>
            </div>
          </div>

          <div class="product-cell">
            <div class="cell-left">
              <img class="product-img" src="../assets/product/cyb.webp" />
              <!-- <div class="product-name">葱油饼</div> -->
            </div>
            <div class="cell-right">
              一畦水土，育一味葱香。伍斋良田寻味至江苏兴化垛田，那里四面环水，垛上沃土滋养出的香葱，细嫩辛香，是这枚葱油饼的魂。<br />
              <strong> 饼胚 · 黄金酥脆</strong> <br />
              精选高筋小麦粉，揉入冰水与少量猪油，反复折叠擀压，形成层层薄如纸的酥皮。煎制时，饼胚在热油中迅速起酥，表面金黄焦脆，内里绵软分层，咬下去“咔嚓”一声，酥屑簌簌落下。<br />
              <strong> 葱香 · 垛田之魂</strong> <br />
              严选兴化垛田当季香葱，只取葱白至葱叶中段最嫩部分，清晨带露采摘，3小时内完成清洗、切末、脱水，锁住最鲜灵的辛香气息。<br />
              <strong> 黄油 · 奶香点睛</strong> <br />
              区别于传统葱油饼的单一油香，伍斋良田特别融入新西兰进口动物黄油，与香葱一同卷入饼胚。黄油在高温下释放出醇厚奶香，与葱辛交织融合，形成独特的风味层次——初入口是黄油的温润奶香，咀嚼间葱香迸发，咸鲜适口，回味悠长。
            </div>
          </div>

          <div class="product-cell">
            <div class="cell-left">
              <img class="product-img" src="../assets/product/yb.jpg" alt="" />
              <!-- <div class="product-name">月饼</div> -->
            </div>
            <div class="cell-right">
              <strong> 甜口代表：</strong
              >豆沙、莲蓉、枣泥、五仁（甜中带坚果香）、黑芝麻等。<br />
              <strong> 咸口代表：</strong
              >蛋黄、火腿、鲜肉等。其中，咸蛋黄和莲蓉的搭配是最经典的组合之一，而云腿月饼则是滇式月饼的招牌<br />
              伍斋良田择取大江南北地道食材，以广式糖浆皮包裹三款传世之味——豆沙的绵、莲蓉的润、火腿的醇，一盒尝遍甜咸风华，致敬记忆深处的团圆月光。<br />
              <strong> 产地严选：</strong
              >新会陈皮、湘潭莲蓉、高邮鸭蛋、宣威火腿、新疆坚果——每一味均有来处，全程可追溯。<br />
              <strong> 手工匠作：</strong
              >沿袭古法手作，揉面、包馅、压模、刷蛋液、烘烤，每枚月饼皆是时间与耐心的诚意之作。<br />
              <strong> 雅致礼盒：</strong
              >新中式鎏金设计，烫印月宫桂兔纹样，内配独立密封托盒，送礼大方体面。<br />
              定制服务：支持企业logo定制，企业团购享专属优惠，详情请咨询客服。<br />
              <strong> 饼皮 · 广式经典</strong> <br />
              传承三代人的糖浆配比，饼皮经72小时回油，色泽金黄油润，薄而柔韧，绵软不粘牙，紧紧锁住丰盈内馅，入口即化。
            </div>
          </div>
        </div>
      </div>

      <!-- <el-collapse v-model="activeNames" @change="handleChange"> </el-collapse> -->
    </div>

    <myFooter class="footer"></myFooter>
  </div>
</template>

<script>
import myFooter from "../components/myFooter.vue";
import myHeader from "../components/myHeader.vue";

export default {
  data() {
    return {
      activeNames: "",
    };
  },
  components: {
    myFooter,
    myHeader,
  },

  methods: {
    handleChange: (val) => {
      console.log(val);
    },
  },
};
</script>

<style lang="less" scoped>
.demo-collapse {
  margin: 90px 0 0px 0;
}

// 产品
.product {
  margin-top: 180px;
  position: relative;
  z-index: -1;
  .fadeinup-titleb {
    width: 100%;
    font-size: 200px;
    font-family: "Micorsoft YaHei";
    font-weight: 700;
    text-align: center;
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    z-index: -1;
    background-image: linear-gradient(
      to bottom,
      rgba(217, 43, 53, 0.3),
      rgba(212, 216, 220, 0)
    );
    position: absolute;
    left: 0;
    top: -150px;
  }

  .product-title {
    font-size: 40px;
    font-weight: 700;
    margin-top: 20px;
    text-align: center;
  }
  .product-list {
    // display: flex;
    // justify-content: space-around;
    margin: 80px 15% 0 15%;
    .product-cell {
      position: relative;
      margin-bottom: 40px;
      display: flex;
      .cell-left {
        width: 400px;
        height: 400px;
        .product-img {
          width: 400px;
          height: 400px;
          border-radius: 20px;
        }
        .product-name {
          background-color: white;
          width: inherit;
          position: absolute;
          left: 0px;
          bottom: 0px;
          opacity: 0.8;
          padding: 10px 20px;
          font-size: 16px;
          font-weight: 700;
        }
      }
      .cell-right {
        margin-left: 40px;
        line-height: 36px;
      }
    }
  }

  .product-more {
    color: #337ab7;
    margin-top: 0px;
    padding-top: 30px;
    text-align: right;
    margin: 0 10vw;
  }
}

.page-title {
  font-size: 40px;
  font-weight: 700;
  line-height: 100px;
  height: 100px;
}

.footer {
  // position: absolute;
  bottom: 0;
  width: 100%;
  margin-top: 50px;
}

@media (max-width: 768px) {
  .page-title {
    font-size: 18px;
  }
  .my-header {
    width: 100vw;
  }

  .mobile {
    .product{
      margin-top: 150px !important;
    }
    .fadeinup-titleb {
      max-width: 100%;
      box-sizing: border-box;
      font-size: 65px !important;
      top: -50px !important;
    }
    .product-list {
      margin: 0;
    }
    .product-img {
      width: 300px !important;
      height: 300px !important;
    }
    .product-cell {
      display: block !important;
    }
    .cell-left {
      text-align: center;
      height: 350px !important;
    }
    .cell-right {
      margin: 0 !important;
      padding: 0 10px;
    }
  }

  .footer {
    position: relative;
    bottom: 0;
    width: 100%;
  }

  .fadeinup-titleb {
    font-size: 60px;
  }
}
</style>
